<template>
    <div class="editor__text text">
        <Spinner v-if="loadingInitial" />
        <!-- TODO move to separate component -->
        <div v-if="showTopPanel" class="top-panel">
            <template v-if="showSearch">
                <TextSearch
                    v-if="book.id && book.limit"
                    ref="textSearchRes"
                    :book="book.id"
                    class="top-panel__search"
                    no-show-all-link
                    @select="onSentenceSearched"
                />
                <div class="top-panel__page">
                    Page
                    <input
                        v-autowidth="{ minWidth: '24px', maxWidth: '30px' }"
                        :value="activePage"
                        placeholder="#"
                        class="top-panel__page-input"
                        :disabled="loading"
                        type="text"
                        @keypress="isNumber($event)"
                        @keypress.enter="onGoToPage($event)"
                    />
                    / {{ totalPages }}
                </div>
            </template>
        </div>
        <div ref="text" class="text__inner">
            <transition name="fade" appear>
                <div
                    v-if="pages.length"
                    class="text__container"
                    :class="{ 'text__container--rtl': isRtl }"
                >
                    <EditorLightTextPage
                        v-for="page in pages"
                        :key="page.id"
                        :active="activePage"
                        :page="page"
                        :playing-part="playingPart"
                        @playPart="onPlayPart"
                    />
                    <div style="height: 100px" />
                </div>
            </transition>
        </div>
        <div class="text__bottom">
            <slot name="bottom" />
        </div>
    </div>
</template>

<script>
import TextSearch from '../TextSearch/TextSearch';
import EditorLightTextPage from '../EditorLightTextPage/EditorLightTextPage';

import { mapActions, mapState, mapGetters } from 'vuex';
import { isRtlLanguage } from '@speechki-frontend/core/editor/utils';

export default {
    name: 'EditorText',
    components: {
        TextSearch,
        EditorLightTextPage
    },
    inject: ['isEmbed'],
    props: {
        pages: {
            type: Array,
            default: () => []
        },
        playingPart: {
            type: Object,
            default: () => undefined
        }
    },
    computed: {
        ...mapState({
            book: state => state.book.book
        }),
        ...mapGetters(['isGuestAccess']),
        ...mapGetters('guestAccess', ['guestAccessActionPermission']),

        ...mapState('pagedBookparts', {
            loading: state => state.loading,
            loadingInitial: state => state.loadingInitial,
            activePage: state => state.activePage
        }),
        ...mapGetters('pagedBookparts', ['totalPages']),

        showTopPanel() {
            if (!this.isGuestAccess) return true;

            if (this.showSearch) {
                return true;
            }

            return this.menubarItems.some(item => item.filter());
        },

        showSearch() {
            if (!this.isGuestAccess) return true;

            return this.guestAccessActionPermission('book', 'search');
        },

        isRtl() {
            return isRtlLanguage(this.book.book_language);
        }
    },

    watch: {
        '$route.query.part'(id) {
            if (!id) {
                return;
            }

            this.$nextTick(() => {
                this.scrollToPart(id);
            });
        }
    },

    async created() {
        await Promise.all([this.fetchTextTypes(), this.fetchBumps(), this.fetchSwapPartTypes()]);
    },

    methods: {
        ...mapActions(['fetchTextTypes', 'fetchBumps', 'fetchSwapPartTypes']),

        scrollToPart(id) {
            let el = this.$el.querySelector(`[data-part="${id}"]`);
            if (el) {
                this.$scrollTo(el, 250, {
                    container: this.$refs.text,
                    offset: -60
                });
            }
        },

        onSentenceSearched(part) {
            this.$emit('search', part);
        },

        onPlayPart(event) {
            this.$emit('playPart', event);
        },

        isNumber(event) {
            const { keyCode } = event;

            if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
                event.preventDefault();
                return false;
            }
            return true;
        },

        onGoToPage(event) {
            if (event.target.value) {
                this.$emit('toPage', Number(event.target.value));
            }
        }
    }
};
</script>
